import React, { useContext } from 'react';

import PointOfContacts from '@totem/components/common/pointOfContact/PointOfContacts';
import { PointOfContact } from '@totem/components/common/pointOfContact/types';
import BuildingContext from '@totem/components/portfolio/buildings/details/container/BuildingContext';
import {
  BUILDINGS_ENDPOINT,
  CONFIGURATION_ENDPOINT,
} from '@totem/utilities/endpoints';

const Contacts = () => {
  const { id, data, isLoading, requestRefresh } = useContext(BuildingContext);

  const handleAction = (action: string, contact: PointOfContact) => {
    if (contact.id !== null) {
      // eslint-disable-next-line default-case
      switch (action) {
        case 'Update':
          requestRefresh();
          break;
        case 'Remove':
          requestRefresh();
          break;
      }
    }
  };

  return (
    <PointOfContacts
      objectType="Building"
      objectId={id}
      loading={isLoading}
      title="Building Contacts"
      data={
        typeof data !== 'undefined' &&
        data !== null &&
        data.building.pointsOfContact !== null
          ? data.building.pointsOfContact
          : []
      }
      canEdit
      onAction={handleAction}
      contactsBaseUrl={`${BUILDINGS_ENDPOINT}/contacts`}
      contactTypesUrl={`${CONFIGURATION_ENDPOINT}/buildingContactTypes`}
    />
  );
};

export default Contacts;
